"use client";
import ShopItemComponent from "@/components/ShopItemComponent";
import { useComponent } from "@/hooks/useMicrositeComponent";
import { cn } from "@/lib/utils";
import {
  IMicrositeComponent,
  MComponentShopItemProps,
} from "@/types/microsite";
import { Fragment } from "react";

const ShopItem = {
  kind: "SHOP_ITEM",
  Render: ({ id, isBuilder, data }) => {
    const { focusTo } = useComponent();

    return (
      <div
        id={id}
        onClick={() => {
          if (id && isBuilder) {
            focusTo(id);
          }
        }}
        className={cn(
          "relative flex flex-col mb-4 px-2",
          data.style === "2-column" ? "w-6/12" : "w-full"
        )}
      >
        {isBuilder ? <div className="absolute inset-0" /> : <Fragment />}
        {data.shopItemId && (
          <ShopItemComponent
            itemId={data.shopItemId}
            itemStyle={data.style}
            id={id}
          />
        )}
      </div>
    );
  },
} as IMicrositeComponent<MComponentShopItemProps>;

export default ShopItem;
